export default __webpack_public_path__ + "static/5-65411b17905093920da99453cd4e971c.jpeg";